module.exports = __webpack_public_path__ + "img/172490 Backup.100c1518.png";